import { useRouter } from 'next/router'
import { MapAccessRequestButton as Button } from 'ui-components'
import { useAuth } from 'user-auth'
import { getUserLink } from 'utils'
import { useSendAccessRequest } from '~map-access/queries/useSendAccessRequest'

export function MapAccessRequestButton() {
  const router = useRouter()
  const { user } = useAuth()
  const { mutateAsync, isPending } = useSendAccessRequest()

  const handleClick = async () => {
    if (!user) return

    await mutateAsync()
    router.push(
      getUserLink({
        userId: user.id,
        firstName: user.firstName as string,
        lastName: user.lastName as string
      })
    )
  }

  return (
    <Button
      loading={isPending}
      onClick={handleClick}
    />
  )
}
